// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The AI disclosure bar (BRAND_SPEC §11.1): Inter 500 13 px in --brand-muted,
 * links underlined in --brand-fg, a 1 px divider below. Never dimmer than
 * #ADADAD, never hidden, never collapsed; the one exception, decided by Alexi,
 * Oct 17, is the front page's first view of a visit, which holds it back
 * until 7.1 s or until anyone starts (ChatView.css .holds-notice, AiDisclosure.js).
 *
 * Two stacked rows in a grid: the full notice (wide screens) and the one-line
 * version (phones, either orientation). 1fr/0fr gives the visible one its
 * real height; padding lives on the inner row so a 0fr row folds to zero.
 */
.ai-disclosure {
  flex: none;
  display: grid;
  grid-template-rows: 1fr 0fr;
  font-size: 0.8125rem;
  line-height: 1.35;
  font-weight: 500;
  color: var(--brand-muted);
  background: var(--brand-bg);
  border-bottom: 1px solid var(--brand-line);
  transition: padding-top var(--dur-base) var(--ease-out);
}

.ai-disclosure-full,
.ai-disclosure-short {
  min-height: 0;
  overflow: hidden;
}

.ai-disclosure-short {
  visibility: hidden;
}

/* The notice on screen lets its links' hit areas (below) reach past its
   edge; the folded one keeps clipping, so its 0fr row stays at zero. */
.ai-disclosure-full {
  overflow: visible;
}

.ai-disclosure-row {
  max-width: calc(var(--column-chat) + 40px);
  margin: 0 auto;
  padding: 9px 20px 10px;
}

.ai-disclosure-full .ai-disclosure-row {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 10px;
  align-items: baseline;
}

.ai-disclosure-short .ai-disclosure-row {
  display: flex;
  align-items: baseline;
  gap: 5px;
  white-space: nowrap;
}

.ai-disclosure-short-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ai-disclosure a {
  flex: none;
  color: var(--brand-fg);
  font-weight: 500;
  text-decoration-line: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.2em;
  white-space: nowrap;
}

.ai-disclosure a:hover {
  text-decoration-thickness: 2px;
}

/* A 44 px hit area for each link (the Crisis help link is 17 px of text),
   invisible and outside the layout, so the bar looks and measures the same;
   the focus ring still hugs the words. One level up, so the conversation's
   first pixels below the bar do not cover it; every overlay (the menu, the
   sign-in card) is far above. */
.ai-disclosure a {
  position: relative;
  z-index: 1;
}

.ai-disclosure a::after {
  content: '';
  position: absolute;
  top: 50%;
  left: -4px;
  right: -4px;
  height: 44px;
  transform: translateY(-50%);
}

/* Phones, either orientation: the one-line notice, always. */
@media (max-width: 720px), (max-height: 500px) {
  .ai-disclosure {
    grid-template-rows: 0fr 1fr;
  }

  .ai-disclosure-full {
    visibility: hidden;
    overflow: hidden;
  }

  .ai-disclosure-short {
    visibility: visible;
    overflow: visible;
  }

  /* Reading (the header is tucked away): the same words, in less height.
     The line now sits at the very top and takes over the safe-area inset. */
  .ai-disclosure.compact {
    padding-top: env(safe-area-inset-top, 0px);
  }

  .ai-disclosure.compact .ai-disclosure-short .ai-disclosure-row {
    padding-top: 3px;
    padding-bottom: 3px;
    line-height: 17px;
  }
}

/* The narrowest phones (320 px, larger text): the line wraps instead of
   clipping "Crisis help" at the edge. */
@media (max-width: 359px) {
  .ai-disclosure-short .ai-disclosure-row {
    flex-wrap: wrap;
    white-space: normal;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AiDisclosure.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;AACF;EACE,UAAU;EACV,aAAa;EACb,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;EAC3B,0CAA0C;EAC1C,uDAAuD;AACzD;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;uEACuE;AACvE;EACE,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;gCAIgC;AAChC;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,6DAA6D;AAC7D;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;4EAC0E;EAC1E;IACE,0CAA0C;EAC5C;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA;wCACwC;AACxC;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF","sourcesContent":["/*\n * The AI disclosure bar (BRAND_SPEC §11.1): Inter 500 13 px in --brand-muted,\n * links underlined in --brand-fg, a 1 px divider below. Never dimmer than\n * #ADADAD, never hidden, never collapsed; the one exception, decided by Alexi,\n * Oct 17, is the front page's first view of a visit, which holds it back\n * until 7.1 s or until anyone starts (ChatView.css .holds-notice, AiDisclosure.js).\n *\n * Two stacked rows in a grid: the full notice (wide screens) and the one-line\n * version (phones, either orientation). 1fr/0fr gives the visible one its\n * real height; padding lives on the inner row so a 0fr row folds to zero.\n */\n.ai-disclosure {\n  flex: none;\n  display: grid;\n  grid-template-rows: 1fr 0fr;\n  font-size: 0.8125rem;\n  line-height: 1.35;\n  font-weight: 500;\n  color: var(--brand-muted);\n  background: var(--brand-bg);\n  border-bottom: 1px solid var(--brand-line);\n  transition: padding-top var(--dur-base) var(--ease-out);\n}\n\n.ai-disclosure-full,\n.ai-disclosure-short {\n  min-height: 0;\n  overflow: hidden;\n}\n\n.ai-disclosure-short {\n  visibility: hidden;\n}\n\n/* The notice on screen lets its links' hit areas (below) reach past its\n   edge; the folded one keeps clipping, so its 0fr row stays at zero. */\n.ai-disclosure-full {\n  overflow: visible;\n}\n\n.ai-disclosure-row {\n  max-width: calc(var(--column-chat) + 40px);\n  margin: 0 auto;\n  padding: 9px 20px 10px;\n}\n\n.ai-disclosure-full .ai-disclosure-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px 10px;\n  align-items: baseline;\n}\n\n.ai-disclosure-short .ai-disclosure-row {\n  display: flex;\n  align-items: baseline;\n  gap: 5px;\n  white-space: nowrap;\n}\n\n.ai-disclosure-short-text {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ai-disclosure a {\n  flex: none;\n  color: var(--brand-fg);\n  font-weight: 500;\n  text-decoration-line: underline;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 0.2em;\n  white-space: nowrap;\n}\n\n.ai-disclosure a:hover {\n  text-decoration-thickness: 2px;\n}\n\n/* A 44 px hit area for each link (the Crisis help link is 17 px of text),\n   invisible and outside the layout, so the bar looks and measures the same;\n   the focus ring still hugs the words. One level up, so the conversation's\n   first pixels below the bar do not cover it; every overlay (the menu, the\n   sign-in card) is far above. */\n.ai-disclosure a {\n  position: relative;\n  z-index: 1;\n}\n\n.ai-disclosure a::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: -4px;\n  right: -4px;\n  height: 44px;\n  transform: translateY(-50%);\n}\n\n/* Phones, either orientation: the one-line notice, always. */\n@media (max-width: 720px), (max-height: 500px) {\n  .ai-disclosure {\n    grid-template-rows: 0fr 1fr;\n  }\n\n  .ai-disclosure-full {\n    visibility: hidden;\n    overflow: hidden;\n  }\n\n  .ai-disclosure-short {\n    visibility: visible;\n    overflow: visible;\n  }\n\n  /* Reading (the header is tucked away): the same words, in less height.\n     The line now sits at the very top and takes over the safe-area inset. */\n  .ai-disclosure.compact {\n    padding-top: env(safe-area-inset-top, 0px);\n  }\n\n  .ai-disclosure.compact .ai-disclosure-short .ai-disclosure-row {\n    padding-top: 3px;\n    padding-bottom: 3px;\n    line-height: 17px;\n  }\n}\n\n/* The narrowest phones (320 px, larger text): the line wraps instead of\n   clipping \"Crisis help\" at the edge. */\n@media (max-width: 359px) {\n  .ai-disclosure-short .ai-disclosure-row {\n    flex-wrap: wrap;\n    white-space: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
